import { createFileRoute } from '@tanstack/react-router';

import MembersSettings from '@/modules/tenant/memberships/pages/Memberships';

export const Route = createFileRoute(
  '/_authenticated/_system/_tenant/settings/',
)({
  head: () => ({
    meta: [{ title: 'Configurações' }],
  }),
  component: MembersSettings,
});
